import React, { useState, useEffect } from 'react'
import { Box } from '@material-ui/core'
import { useStyles } from './SchoolNews_style'
import SchoolAPI from 'api/SchoolAPI'
import TrendingArticlesContainer from 'components/TrendingArticlesContainer/TrendingArticlesContainer'
import CTAAlert from 'components/CTAAlert/CTAAlert'
import { SCHOOL_INDEX_SCHOOL_NEWS } from 'assets/AlertsHelper'
import isEmpty from 'lodash.isempty'

const SchoolNews = (props) => {
    const { user } = props
    const classes = useStyles()
    const [mainArticle, setMainArticle] = useState(null)
    const [minimalArticles, setMinimalArticles] = useState([])
    const [listArticles, setListArticles] = useState([])
    const [mobileArticles, setMobileArticles] = useState([])

    useEffect(() => {
        SchoolAPI.GetSchoolNews().then((response) => {
            setMainArticle(response.data.main_article)
            setMinimalArticles(response.data.minimal_articles)
            setListArticles(response.data.list_articles)
            setMobileArticles(response.data.mobile_articles)
        })
    }, [])

    if (isEmpty(mainArticle)) return null

    return (<>
        <TrendingArticlesContainer
            mainArticle={mainArticle}
            minimalArticles={minimalArticles}
            listArticles={listArticles}
            mobileArticles={mobileArticles}
            titleId='school_index.school_news.title'
            descriptionId='school_index.school_news.description'
            showMoreButtonArticleCategory='education'
        />
        <Box className={classes.ctaBox}>
            <CTAAlert
                type='student_job'
                user={user}
                componentType='banner'
                origin={SCHOOL_INDEX_SCHOOL_NEWS}
            />
        </Box>
    </>)
}

export default SchoolNews
